import React, { useState } from "react";
import "../../Styles/animation.css"; // keep your fade/slide animations
import performRequest from "../../Api/request";

export default function NewsletterSection() {


  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!email.trim()) {
      alert("Please enter a valid email");
      return;
    }
  
    try {
      const data = { 
        email, 
        consent_source: "kryzen info" 
      };
  
      const response = await performRequest("POST", "/news-letter/subscribe-email", data);
      
      alert("Subscribed successfully!");
      setEmail(""); // Clear input after success
      console.log("Success:", response);
    } catch (error) {
      console.error("Subscription failed:", error);
      alert("Something went wrong. Please try again.");
    }
  };
  return (
    <section className="py-5 py-md-7 bg-light" id="newsletter">
      <div className="container-xl">
        <div
          className="card shadow-lg border-0 fade-in mx-auto"
          style={{ maxWidth: 760 }}
        >
          <div className="card-body p-4 p-md-5 text-center">
            {/* Tag */}
            <span className="text-green fs-2 fw-bold text-uppercase tracking-wide small">
              Kryzen Insights
            </span>

            {/* Title */}
            <h2 className="mt-2 mb-2 fw-bold text-dark">
              Get the Latest Hydroponic & Agri-Tech Insights
            </h2>

            {/* Subtitle */}
            <p
              className="text-secondary mx-auto mb-4"
              style={{ maxWidth: 600 }}
            >
              Join thousands of growers and agri-entrepreneurs receiving curated
              updates on hydroponics, smart farming, automation systems, and
              Kryzen’s latest innovations — straight to your inbox.
            </p>

            {/* Form */}
            <form onSubmit={handleSubmit}>
              <div className="row g-2 justify-content-center">
                <div className="col-12 col-md-7">
                  <input
                    type="email"
                    className="form-control form-control-lg"
                    placeholder="Enter your email address"
                    value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
                  />
                </div>

                <div className="col-12 col-md-4">
                  <button
                    type="submit"
                    className="btn btn-success btn-lg w-100"
                 
                  >
                    Subscribe Now
                  </button>
                </div>
              </div>

              <p className="text-secondary mt-3 small">
                Expect only valuable information, offers, and updates that help
                you grow with us.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
